// extracted by mini-css-extract-plugin
module.exports = {"day":"_2Ch72-R4E6qY","dayOfWeekName":"WIzUHTL0pDF2"};